function SignalMetaAssignment() {
    /// <summary>
    /// This object provides client side functions for the report signal meta visual <br/>
    /// <br/>
    /// it fills the form items and sends them to the webserver for saving
    /// Author: MWI<br />
    /// Date: 06.03.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
     /// ***********************************************************************<br />
    /// *** v1.0.0 - 06.03.2018                                               *<br />
    /// ***********************************************************************<br />
    /// * - basic functionality                                               *<br />
    /// ***********************************************************************<br />
    /// </summary>
}
SignalMetaAssignment.prototype = new window.vcTemplate();
SignalMetaAssignment.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it does nothing more than adding the clickhandler and creating the filters
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return;
        }
        me.height = me.visual.find("#report-template-creation").height();
        me.showInfo("", "", true);
        me.visual.find("#lstSignals .filter").vcFilter({ callback: function () { me.filter("#lstSignalsUL"); } });
        me.visual.find("#lstMeta .filter").vcFilter({ callback: function () { me.filter("#lstMetaUL"); } });
        me.visual.find("#lstMeta .report-info-tooltip").tipTip();

        me.initClickHandler();
    } catch (ex) {
        me.writeError("SignalMetaAssignment.init", ex);
    }

};
SignalMetaAssignment.prototype.validate = function () {
    ///<summary>
    /// validates the inputs from the user on the client side
    ///</summary>
    var me = this;
    var bRet = true;
    var testObj, parsed;
    //var maxPeriod = -1;
    try {
        parsed = parseInt(me.visual.find("#duration").val(), 10);
        testObj = me.fillReportInfoObject(1);
       
        if (testObj !== null) {
            me.visual.find("#duration").toggleClass("error", false);
            me.visual.find("#lstSignals, #lstMeta").toggleClass("error", false);
            me.visual.find("#lstSignals .caption, #lstMeta .caption").toggleClass("icon-color-error", false);
            if (JSON.parse(testObj.bsagids).length === 0 && JSON.parse(testObj.mtagids).length === 0) {
                me.visual.find("#lstSignals, #lstMeta").toggleClass("error", true);
                me.visual.find("#lstSignals .caption, #lstMeta .caption, #selectionHelp").toggleClass("icon-color-error", true);
                me.visual.find("#lstSignals .caption .fa-exclamation-triangle, #lstMeta .caption .fa-exclamation-triangle").remove();
                me.visual.find("#lstSignals .caption, #lstMeta .caption").prepend("<i class='fa fa-exclamation-triangle  fa-lg icon-color-error' title='" + me.resources.err_NoEntriesSelected + "'></i> ");

                me.visual.find("#divBtnSaveReportTemplate").button("option", "disabled", true);
                bRet = false;
            } else {
                me.visual.find("#lstSignals .caption .fa-exclamation-triangle, #lstMeta .caption .fa-exclamation-triangle").remove();

                me.visual.find("#lstSignals .caption, #lstMeta .caption,  #selectionHelp").toggleClass("icon-color-error", false);
            }
          
            me.visual.find("#lstMeta .vc-list-item.selected .vc-list-text.report-info-tooltip").each(function(idx, element) {
                var cnt = 0;
                var signals = $(element).data("signals");
                for (var i = 0; i <= signals.length - 1; i++) {
                    cnt += me.visual.find(".vc-list-item.selected[data-id='" + signals[i] +"']").length;
                }
                if (cnt === 0) {
                    $(element).parents(".vc-list-item").addClass("error no-signal");
                    $(element).siblings(".fa.icon-selector").removeClass("icon-color-info").addClass("icon-color-error");
                } else {
                    $(element).parents(".vc-list-item").removeClass("error no-signal");
                    $(element).siblings(".fa.icon-selector").addClass("icon-color-info").removeClass("icon-color-error");}
            });

            setTimeout(function () {if (me.visual.find(".no-signal").length >= 1) {
                        me.visual.find("#divBtnSaveReportTemplate").button("option", "disabled", true);
                        bRet = false;
                    }}, 100);
                

            if (bRet) {
                me.visual.find("#divBtnSaveReportTemplate").button("option", "disabled", false);
                me.showInfo("", "", false);
                        me.visual.find("#report-template-creation").height(me.height);

            }
        }
        window._VCMQ.produce(me.visual, me.vcgid, "REP_CONFIG_VALID", { "valid": bRet, "step": 1 });

    } catch (ex) {
        me.writeError("SignalMetaAssignment.validate", ex);
    }
    return bRet;
};
SignalMetaAssignment.prototype.filter = function (list) {
    /// <summary>
    ///  This function shows/hides items of the given list. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //hide all
        me.visual.find(list +" .vc-list-item").removeClass("found").data("counter", 0).hide();
        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", list + " .vc-list-item", "found");
        me.visual.find(list + " .vc-list-item.found").show();
        return true;
    } catch (ex) {
        me.writeError('vcTopologySankey.filterList', ex);
        return false;
    }

};
SignalMetaAssignment.prototype.fillLists = function (sList, sElements) {
    /// <summary>
    ///  this function fills the lists th its items
    /// </summary>
    var me = this;
    try {
        if (sElements !== undefined) {
            for (var i = 0; i < sElements.length; i++) {
                me.visual.find(sList + " .vc-list-item[data-id=" + parseInt(sElements[i], 10) + "]").trigger("click");
            }
        }

            me.validate();
    } catch (ex) {
        me.writeError("SignalMetaAssignment.fillLists", ex);
    }

};
SignalMetaAssignment.prototype.btnSave = function () {
    /// <summary>
    /// Handles the click of the save button for the SignalMetaAssignment <br/>
    /// by retrieving all values and sending them to the webservice
    /// </summary>
    var me = this;
 
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);



        if (me.visual.find("#divBtnSaveReportTemplate").button("option", "disabled")) {return false; }
        me.visual.find("#divBtnSaveReportTemplate i.fa-check").hide();
        if (me.validate() === true) {
            window.VisualCoreService.updateData(me.vcvid,me.vcgid,window.getCurrentTimestamp(),0,0,"","",2,2,JSON.stringify(me.reportInfo),function(res) {
                    me.saveReportReturn(me, res);
                });
        } else {
            me.visual.find("#divBtnSaveReportTemplate").button("option", "disabled", "disabled");
        }
        return true;
    } catch (ex) {
        me.writeError("SignalMetaAssignment.btnSave", ex); return false;
    }
};
SignalMetaAssignment.prototype.saveReportReturn = function (me, res) {
    /// <summary>
    ///  This is the return point of the webservice for the client 
    /// </summary>
    try {
        if (res.rrid !== -1) {
            me.visual.find("#divBtnSaveReportTemplate i.fa-check").show();
            me.showInfo(me.resources.saveSuccess, "", false);
        } else {
            me.showInfo(me.resources.err_saveData, "", true);
        }
    } catch (ex) {
        me.writeError("SignalMetaAssignment.saveReportReturn", ex);
    }
};
SignalMetaAssignment.prototype.initClickHandler = function () {
    /// <summary>
    /// Initializes all clickhandlers once 
    /// </summary>
    var me = this;
    var bRet = true;
    try {
        if (me.error) {
            bRet = false;
        } else {
       
            me.visual.find('#divBtnSaveReportTemplate').button().off("click").on("click", function() { me.btnSave(); })
                .css({ margin: 0 });
            me.visual.find(".vc-list-item").off("click").on("click",
                function() {
                    $(this).toggleClass("selected");
                    $(this).toggleClass("error no-signal", false);
                    $(this).find(".icon-selector").removeClass("icon-color-error").addClass("icon-color-info");
                    $(this).find(".icon-selector").toggleClass("fa-square");
                    $(this).find(".icon-selector").toggleClass("fa-check-square");
                    me.validate();

                });
            me.fillLists("#lstSignals", me.bsagids);
            me.fillLists("#lstMeta", me.mtagids);
           
            me.visual.find("#lstMeta .vc-list-select-all .chb-signal-selection").off("change").on("change",
                function () {
                    me.toggleListElements("#lstMeta", this);
                    me.validate();                      
            });
            
            me.visual.find("#lstSignals .vc-list-select-all .chb-signal-selection").off("change").on("change",
                function () {
                    me.toggleListElements("#lstSignals", this);
                    me.validate();
                });
            me.visual.find("#duration").off("change keyup").on("change keyup", function() { me.validate(); });
            me.visual.find("#period, #duration").trigger("change");

        }
    } catch (ex) {
        me.writeError("SignalMetaAssignment.initClickHandler", ex); bRet = false;
    }
    return bRet;
};
SignalMetaAssignment.prototype.toggleListElements = function (list, checkbox) {
    /// <summary>
    /// Toggles the checkboxes in the list elements
    /// </summary>
    var me = this;
    try {
        if (checkbox.checked === true) {
            me.visual.find(list + " .vc-list-item").removeClass("selected");
            me.visual.find(list + " .vc-list-item").addClass("selected");
            me.visual.find(list + " .vc-list-item").find(".icon-selector").removeClass("fa-square");
            me.visual.find(list + " .vc-list-item").find(".icon-selector").addClass("fa-check-square");
        } else {
            me.visual.find(list + " .vc-list-item").removeClass("selected");
            me.visual.find(list + " .vc-list-item").find(".icon-selector").removeClass("fa-check-square");
            me.visual.find(list + " .vc-list-item").find(".icon-selector").addClass("fa-square");
        }
    } catch (ex) {
        me.writeError("SignalMetaAssignment.toggleListElements", ex);
    }
};
SignalMetaAssignment.prototype.specificInfoHandling = function () {
    /// <summary>
    /// This function  hides/fades out the fieldsets resp. the complete div on error
    /// </summary>
    var me = this;
    try {
         me.visual.find("#report-template-creation").height(me.height- 60);
        return true;
    } catch (ex) {
        me.writeError("SignalMetaAssignment.specificInfoHandling", ex);
        return false;
    }
};
SignalMetaAssignment.prototype.fillReportInfoObject = function (updateType) {
    /// <summary>
    /// Fills out all the information about the report to send to the server
    /// </summary>
    var me = this;
    var bsagids = [];
    var mtagids = [];
    try {
        me.reportInfo = new Object();

        me.reportInfo.updateType = updateType;
        me.reportInfo.rrid = me.rrid;
        
        me.visual.find("#lstSignals .vc-list-item.selected")
            .each(function (idx, element) { bsagids.push($(element).attr("data-id")); });
        me.reportInfo.bsagids = JSON.stringify(bsagids);

        me.visual.find("#lstMeta .vc-list-item.selected").each(function (idx, element) { mtagids.push($(element).attr("data-id")); });
        me.reportInfo.mtagids = JSON.stringify(mtagids);
        return me.reportInfo;
    } catch (ex) {
        me.writeError("SignalMetaAssignment.fillReportInfoObject", ex);
        return null;
    }
};